import { render, staticRenderFns } from "./officialSupportApp.vue?vue&type=template&id=457cbdc1&"
import script from "./officialSupportApp.vue?vue&type=script&lang=js&"
export * from "./officialSupportApp.vue?vue&type=script&lang=js&"
import style0 from "./officialSupportApp.vue?vue&type=style&index=0&id=457cbdc1&prod&lang=css&"
import style1 from "./officialSupportApp.vue?vue&type=style&index=1&id=457cbdc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports